import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { LogOut, Shield } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_mls-deadline-master/artifacts/jbrp9xqq_equitasfit%20%28Logo%29%20%284%29.png";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 w-full border-b border-stone-200 bg-[#faf7f2]/85 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5">
        <Link
          to="/app"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="Equitas 1%"
            className="h-11 w-11 rounded-full object-cover shadow-sm ring-1 ring-stone-200"
          />
          <div className="flex flex-col leading-none">
            <span className="overline text-stone-500">Equitas Homes</span>
            <span className="text-lg font-heading font-semibold tracking-tight text-stone-900 mt-1">
              Listing Workflow
            </span>
          </div>
        </Link>

        {user && (
          <div className="flex items-center gap-5">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-xs text-stone-500">{user.email}</span>
              <span className="text-sm font-medium text-stone-900">{user.name}</span>
            </div>
            {user.role === "admin" && (
              <Link
                to="/admin"
                data-testid="header-admin-link"
                className="hidden sm:inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-stone-500 hover:text-[#010082] transition-colors"
              >
                <Shield className="h-3 w-3" />
                Admin
              </Link>
            )}
            <Button
              data-testid="logout-button"
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="border-stone-300 rounded-full px-4"
            >
              <LogOut className="h-3.5 w-3.5 mr-1.5" />
              Log out
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
